import { combineReducers } from 'redux'
import biddingReducer from './bidding'
import userReducer from './user'

export default combineReducers({ bidding: biddingReducer, user: userReducer })
